import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const shipLinesAdapter = getAdapter({ idFieldName: 'value' });

const shipLinesSlice = createSlice({
  name: 'shipLines',
  initialState: shipLinesAdapter.getInitialState(),
  reducers: {
    setShipLines: (state, { payload: { shipLines } }) => {
      shipLinesAdapter.setAll(state, shipLines);
    },
  },
});

const selectors = shipLinesAdapter.getSelectors(({ shipLines }) => shipLines);

export const getShipLines = (state) => selectors.selectAll(state);

export const {
  setShipLines
} = shipLinesSlice.actions;

export default shipLinesSlice.reducer;